import React from 'react';
import {createRoot} from 'react-dom/client';
import MedicalReportDashboard from "./components/medicalReport/MedicalReportDashboard";
import PaymentStatus from './components/payment/paymentstatus';
import RenewCoverage from "./components/renewCoverage/RenewCoverage";
import PaymentHistory from "./components/payment/payment-history/PaymentHistory";
import SickLeave from "./components/sickleave/SickLeave";
import MedicalFitnessCheckDashboard from "./components/medicalFitnessCheck/MedicalFitnessCheckDashboard";
import OtherServicesDashboard from './components/otherServicesDashboard/OtherServicesDashboard';
import ManageDependents from './components/manageDependents/index';
import DigitalHealthCard from "./components/digitalHealthCard/DigitalHealthCard";
import SmartRegistration from './components/smartRegistration/index'
import SickLeaveQrVefication from "./components/sickleave/SickLeaveQrVefication";
import EscortQrVerification from "./components/escortLeave/EscortQrVertification";
import ViewMrn from './components/viewMrn/index';
import BloodDonation from './components/bloodDonation';
import BaraemServices from './components/baraemServices';
import HappinessMeter from './components/happinessMeter/HappinessMeter';
import BaraemAnalytics from "./components/baraemAnalytics/BaraemAnalytics";
import QrCodeSms from './components/bloodDonation/QrCodeSms/QrCodeSms';
import PaymentReconcilliation from "./components/paymentReconcilliation/PaymentReconcilliation";
import PaymentRefund from "./components/paymentRefund/PaymentRefund";
import EscortLeave from './components/escortLeave/EscortLeave';

const ELEMENT_ID_MEDICAL_REPORT_DASHBOARD = 'liferay-dha-medical-report-dashboard';

const ELEMENT_ID_PAYMENT_STATUS = 'liferay-dha-payment-status';
const ELEMENT_ID_SICK_LEAVE = 'liferay-dha-sick-leaves';
const ELEMENT_ID_ESCORT_LEAVE = 'liferay-dha-escort-leaves';
const ELEMENT_ID_SLA_QR_INFO = "liferay-dha-sick-leave-qr-status"
const ELEMENT_ID_ES_QR_INFO = "liferay-dha-escort-leave-qr-status"
const ELEMENT_ID_MANAGE_DEPENDENT = 'liferay-dha-manage-dependent';
const ELEMENT_ID_OTHER_DASHBOARD = 'liferay-dha-other-dashboard-services';
const ELEMENT_ID_PAYMENT_HISTORY = 'liferay-dha-payment-history';
const ELEMENT_ID_RENEW_HEALTH_CARD = 'liferay-dha-renew-health-card';
const ELEMENT_ID_MEDICAL_FITNESS = 'liferay-dha-medical-fitness';
const ELEMENT_ID_SMART_REGISTRATION = 'liferay-dha-smart-registration';
const VIEWMRN_REPORT_ELEMENT_ID = 'liferay-dha-viewmrn-report-dashboard';
const ELEMENT_ID_DIGITAL_HEALTH_CARD = 'liferay-dha-digital-health-card';
const ELEMENT_ID_BLOOD_DONATION = 'liferay-dha-blood-donation';
const ELEMENT_ID_Baraem_Service = 'liferay-dha-baraem-service';
const ELEMENT_ID_HAPPINESS_METER = 'liferay-dha-happiness-meter';
const ELEMENT_ID_BARAEM_ANALYTICS = 'liferay-dha-baraem-analytics';
const ELEMENT_ID_BLOOD_DONATION_QR_CODE = 'liferay-dha-blood-donation-qr-code';
const ELEMENT_ID_PAYMENT_CONCILLIATION = 'liferay-dha-payment-concilliation';
const ELEMENT_ID_PAYMENT_REFUND = 'liferay-dha-payment-refund';


class WebComponentPaymentRefund extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<PaymentRefund/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentPaymentConcilliation extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<PaymentReconcilliation/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentManageDependent extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<ManageDependents/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentOtherDashboardServices extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<OtherServicesDashboard/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentMedicalReportDashboard extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<MedicalReportDashboard/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentSickLeave extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);

        this.root.render(<SickLeave/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}
class WebComponentEscortLeave extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);

        this.root.render(<EscortLeave/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}
class ViewMrnWebComponent extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<ViewMrn/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentPaymentStatus extends HTMLElement {
    connectedCallback() {
        const componentElement = this;
        const props = {
            amount: componentElement.getAttribute('amount'),
            paymentstatus: componentElement.getAttribute('paymentstatus'),
            trnNumber: componentElement.getAttribute('trnNumber'),
            refNumber: componentElement.getAttribute('refNumber'),
            servCode: componentElement.getAttribute('servCode'),
            serviceLanguage: componentElement.getAttribute('serviceLanguage')
        };
        this.root = createRoot(this);
        this.root.render(<PaymentStatus {...props} />);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentPaymentHistory extends HTMLElement {
    connectedCallback() {
        const componentElement = this;
        const props = {
            salamaRequestType: componentElement.getAttribute('salamaRequestType')
        };
        this.root = createRoot(this);
        this.root.render(<PaymentHistory {...props} />);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentRenewHealthCard extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<RenewCoverage/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentMedicalFitness extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<MedicalFitnessCheckDashboard/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentDigitalHealthCard extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<DigitalHealthCard/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentSmartRegistration extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<SmartRegistration/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentBloodDonationDashboard extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<BloodDonation/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentEscortLeaveQrVefication extends HTMLElement {
    constructor() {
        super();
        this.root = null;
    }

    connectedCallback() {
        this.root = createRoot(this);
        const componentElement = this;
        const decryptJson = componentElement.getAttribute('decryptJson');
        this.root.render(<EscortQrVerification decryptJson={decryptJson}/>);
    }

    disconnectedCallback() {
        if (this.root) {
            this.root.unmount();
            delete this.root;
        }
    }
}

class WebComponentSickLeaveQrVefication extends HTMLElement {
    constructor() {
        super();
        this.root = null;
    }

    connectedCallback() {
        this.root = createRoot(this);
        const componentElement = this;
        const decryptJson = componentElement.getAttribute('decryptJson');
        this.root.render(<SickLeaveQrVefication decryptJson={decryptJson}/>);
    }

    disconnectedCallback() {
        if (this.root) {
            this.root.unmount();
            delete this.root;
        }
    }
}

class WebComponentBloodDonationQRCode extends HTMLElement {
    constructor() {
        super();
        this.root = null;
    }

    connectedCallback() {
        this.root = createRoot(this);
        const componentElement = this;
        const qrCodeValue = componentElement.getAttribute('qrCodeValue');
        const locale = componentElement.getAttribute('locale');
        const dateModified = componentElement.getAttribute('dateModified');
        this.root.render(<QrCodeSms qrCodeValue={qrCodeValue} locale={locale} dateModified={dateModified}/>);
    }

    disconnectedCallback() {
        if (this.root) {
            this.root.unmount();
            delete this.root;
        }
    }
}

class WebComponentBaraemService extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<BaraemServices/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class WebComponentHappinessMeter extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);
        this.root.render(<HappinessMeter/>, this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

class BaraemAnalyticsComponent extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);

        this.root.render(
            <BaraemAnalytics/>
        );
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

if (!customElements.get(ELEMENT_ID_MEDICAL_REPORT_DASHBOARD)) {
    customElements.define(ELEMENT_ID_MEDICAL_REPORT_DASHBOARD, WebComponentMedicalReportDashboard);
}
if (!customElements.get(ELEMENT_ID_SICK_LEAVE)) {
    customElements.define(ELEMENT_ID_SICK_LEAVE, WebComponentSickLeave);
}
if (!customElements.get(ELEMENT_ID_ESCORT_LEAVE)) {
    customElements.define(ELEMENT_ID_ESCORT_LEAVE, WebComponentEscortLeave);
}
if (!customElements.get(ELEMENT_ID_PAYMENT_STATUS)) {
    customElements.define(ELEMENT_ID_PAYMENT_STATUS, WebComponentPaymentStatus);
}
if (!customElements.get(ELEMENT_ID_PAYMENT_HISTORY)) {
    customElements.define(ELEMENT_ID_PAYMENT_HISTORY, WebComponentPaymentHistory);
}
if (!customElements.get(ELEMENT_ID_RENEW_HEALTH_CARD)) {
    customElements.define(ELEMENT_ID_RENEW_HEALTH_CARD, WebComponentRenewHealthCard);
}
if (!customElements.get(ELEMENT_ID_MEDICAL_FITNESS)) {
    customElements.define(ELEMENT_ID_MEDICAL_FITNESS, WebComponentMedicalFitness);
}

if (!customElements.get(ELEMENT_ID_MANAGE_DEPENDENT)) {
    customElements.define(ELEMENT_ID_MANAGE_DEPENDENT, WebComponentManageDependent);
}
if (!customElements.get(ELEMENT_ID_OTHER_DASHBOARD)) {
    customElements.define(ELEMENT_ID_OTHER_DASHBOARD, WebComponentOtherDashboardServices);
}
if (!customElements.get(VIEWMRN_REPORT_ELEMENT_ID)) {
    customElements.define(VIEWMRN_REPORT_ELEMENT_ID, ViewMrnWebComponent);
}

if (!customElements.get(ELEMENT_ID_DIGITAL_HEALTH_CARD)) {
    customElements.define(ELEMENT_ID_DIGITAL_HEALTH_CARD, WebComponentDigitalHealthCard)
}

if (!customElements.get(ELEMENT_ID_SMART_REGISTRATION)) {
    customElements.define(ELEMENT_ID_SMART_REGISTRATION, WebComponentSmartRegistration);
}

if (!customElements.get(ELEMENT_ID_SLA_QR_INFO)) {
    customElements.define(ELEMENT_ID_SLA_QR_INFO, WebComponentSickLeaveQrVefication);
}

if (!customElements.get(ELEMENT_ID_ES_QR_INFO)) {
    customElements.define(ELEMENT_ID_ES_QR_INFO, WebComponentEscortLeaveQrVefication);
}

if (!customElements.get(ELEMENT_ID_BLOOD_DONATION)) {
    customElements.define(ELEMENT_ID_BLOOD_DONATION, WebComponentBloodDonationDashboard);
}

if (!customElements.get(ELEMENT_ID_Baraem_Service)) {
    customElements.define(ELEMENT_ID_Baraem_Service, WebComponentBaraemService);
}
if (!customElements.get(ELEMENT_ID_HAPPINESS_METER)) {
    customElements.define(ELEMENT_ID_HAPPINESS_METER, WebComponentHappinessMeter);
}

if (!customElements.get(ELEMENT_ID_BARAEM_ANALYTICS)) {
    customElements.define(ELEMENT_ID_BARAEM_ANALYTICS, BaraemAnalyticsComponent);
}

if (!customElements.get(ELEMENT_ID_BLOOD_DONATION_QR_CODE)) {
    customElements.define(ELEMENT_ID_BLOOD_DONATION_QR_CODE, WebComponentBloodDonationQRCode);
}

if (!customElements.get(ELEMENT_ID_PAYMENT_CONCILLIATION)) {
    customElements.define(ELEMENT_ID_PAYMENT_CONCILLIATION, WebComponentPaymentConcilliation);
}

if (!customElements.get(ELEMENT_ID_PAYMENT_REFUND)) {
    customElements.define(ELEMENT_ID_PAYMENT_REFUND, WebComponentPaymentRefund);
}
